module.exports = __webpack_public_path__ + "./kit/docs/img/icon-search-purple.74d2f7f4fed77a4741e649d966863496.svg";